const japanPrefectures = {
  OVERSEA: '海外',
  HOKKAIDO: '北海道',
  AOMORI: '青森县',
  IWATE: '岩手县',
  MIYAGI: '宫城县',
  AKITA: '秋田县',
  YAMAGATA: '山形县',
  FUKUSHIMA: '福岛县',
  IBARAKI: '茨城县',
  TOCHIGI: '枥木县',
  GUNMA: '群马县',
  SAITAMA: '琦玉县',
  CHIBA: '千叶县',
  TOKYO: '东京都',
  KANAGAWA: '神奈川县',
  NIIGATA: '新潟县',
  TOYAMA: '富山县',
  ISHIKAWA: '石川县',
  FUKUI: '福井县',
  YAMANASHI: '山梨县',
  NAGANO: '长野县',
  GIFU: '岐阜县',
  SHIZUOKA: '静冈县',
  AICHI: '爱知县',
  MIE: '三重县',
  SHIGA: '滋贺县',
  KYOTO: '京都府',
  OSAKA: '大阪府',
  HYOGO: '兵库县',
  NARA: '奈良县',
  WAKAYAMA: '和歌山县',
  TOTTORI: '鸟取县',
  SHIMANE: '岛根县',
  OKAYAMA: '冈山县',
  HIROSHIMA: '广岛县',
  YAMAGUCHI: '山口县',
  TOKUSHIMA: '德岛县',
  KAGAWA: '香川县',
  EHIME: '爱媛县',
  KOCHI: '高知县',
  FUKUOKA: '福冈县',
  SAGA: '佐贺县',
  NAGASAKI: '长崎县',
  KUMAMOTO: '熊本县',
  OITA: '大分县',
  MIYAZAKI: '宫崎县',
  KAGOSHIMA: '鹿儿岛县',
  OKINAWA: '冲绳县'
};

export default japanPrefectures;
